// src/store/ui.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStore = defineStore('ui', () => {
  const drawer = ref(false);
  return { drawer };
});
